import React from "react";
import PropTypes from "prop-types";
import { Modal } from "react-bootstrap";

// styles
import * as styles from "./BioModal.module.css";

const BioModal = ({ show, onHide, member }) => {
  if (!member) return null;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      size="lg"
      className={styles.bioModal}
      dialogClassName={styles.bioModalDialog}
    >
      <Modal.Body className={styles.bioModalBody}>
        {/* Close Button */}
        <button
          type="button"
          className={styles.closeButton}
          onClick={onHide}
          aria-label="Close"
        >
          Close
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M15 5L5 15M5 5L15 15"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className={styles.modalContent}>
          {/* Left Section - Profile */}
          <div className={styles.leftSection}>
            <div className={styles.profileImage}>{member.drImage}</div>
            <h2 className={styles.memberName}>{member.drName}</h2>
            <p className={styles.memberDesignation}>{member.designation}</p>
            {member.company && (
              <p className={styles.memberCompany}>{member.company}</p>
            )}
          </div>

          {/* Right Section - Bio Content */}
          <div className={styles.rightSection}>
            {member.content1 && (
              <p className={styles.bioParagraph}>{member.content1}</p>
            )}
            {member.content2 && (
              <p className={styles.bioParagraph}>{member.content2}</p>
            )}
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

BioModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  member: PropTypes.shape({
    drName: PropTypes.string,
    designation: PropTypes.string,
    company: PropTypes.string,
    drImage: PropTypes.node,
    content1: PropTypes.string,
    content2: PropTypes.string,
  }),
};

export default BioModal;
